import { render } from "./ResultsAfterBuilding.vue?vue&type=template&id=029463e4"
import script from "./ResultsAfterBuilding.vue?vue&type=script&lang=js"
export * from "./ResultsAfterBuilding.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__